import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ProposalResponse.scss';
var ProposalResponse = /*#__PURE__*/function (_Component) {
  function ProposalResponse() {
    _classCallCheck(this, ProposalResponse);
    return _callSuper(this, ProposalResponse, arguments);
  }
  _inherits(ProposalResponse, _Component);
  return _createClass(ProposalResponse, [{
    key: "renderNotes",
    value: function renderNotes() {
      var _this = this;
      var _this$props = this.props,
        notes = _this$props.notes,
        extraSpanClasses = _this$props.extraSpanClasses;
      if (notes) {
        return /*#__PURE__*/React.createElement("div", {
          ref: function ref(el) {
            _this.notesElement = el;
          },
          className: "g-column body-text-3 ".concat(extraSpanClasses)
        }, notes);
      }
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          _this.notesElement = el;
        },
        className: "hide"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        checked = _this$props2.checked,
        description = _this$props2.description,
        extraClasses = _this$props2.extraClasses,
        notes = _this$props2.notes;
      return /*#__PURE__*/React.createElement("div", {
        className: "proposal-response ".concat(checked, " ").concat(extraClasses)
      }, description ? [/*#__PURE__*/React.createElement("strong", null, description), this.renderNotes()] : notes);
    }
  }]);
}(Component);
ProposalResponse.propTypes = {
  checked: PropTypes.string,
  description: PropTypes.string,
  notes: PropTypes.string,
  extraClasses: PropTypes.string,
  extraSpanClasses: PropTypes.string
};
ProposalResponse.defaultProps = {
  checked: '',
  description: '',
  notes: '',
  extraClasses: '',
  extraSpanClasses: ''
};
export default ProposalResponse;